// export const Baseurl = "http://localhost:4030";
export const Baseurl = "https://instavaluermainapi.instavaluer.com";
